import * as LabelPrimitive from '@radix-ui/react-label';
import { cn, cva } from '@thinkalpha/ui-core/utils';
import type { VariantProps } from '@thinkalpha/ui-core/utils';
import * as React from 'react';

const labelVariants = cva('text-md leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

const Label = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
